<template>
  <Teleport to="#modals">
    <Modal v-if="showNotification" @close="handleClose">
      <template #header-all>
        <h2 v-if="isCriticalExpiredPassword">&nbsp;</h2>
        <BackButton v-else :click="handleClose" type="button">
          Отмена
        </BackButton>
      </template>
      <template #content>
        <div class="notification-content">
          <p>
            Срок действия вашего текущего пароля истечет через
            {{ me?.days_before_password_expires }}
            {{
              pluralize(me?.days_before_password_expires || 0, [
                'день',
                'дня',
                'дней',
              ])
            }}. <br />Рекомендуем заранее придумать и установить новый пароль.
          </p>
          <div class="notification-actions">
            <button
              class="btn btn-next"
              type="button"
              @click="handleChangePassword"
            >
              Сменить пароль
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue'
import Modal from '@/components/Modal.vue'
import BackButton from '@/components/BackButton.vue'
import useAuth from '@/utils/useAuth'
import { pluralize } from '@/utils/helpers'
import { useRouter } from 'vue-router'
import { NOTIFICATION_KEY } from '@/constants'

const emit = defineEmits(['change-password'])

const router = useRouter()
const { me, isCriticalExpiredPassword, isExpireSoonPassword } = useAuth()
const showNotification = ref(false)

/**
 * Проверяет, было ли показано уведомление
 */
const wasShownToday = () => {
  const lastShown = localStorage.getItem(NOTIFICATION_KEY)
  if (!lastShown) return false

  const lastShownDate = new Date(parseInt(lastShown))
  const today = new Date()

  return (
    lastShownDate.getDate() === today.getDate() &&
    lastShownDate.getMonth() === today.getMonth() &&
    lastShownDate.getFullYear() === today.getFullYear()
  )
}

// Сохраняем информацияю что уже показывали уведомление
const markAsShown = () => {
  const now = new Date().getTime()
  localStorage.setItem(NOTIFICATION_KEY, now.toString())
}

const handleChangePassword = () => {
  if (isCriticalExpiredPassword.value) {
    router.push({ name: 'ChangePassword' })
    return
  }

  emit('change-password')
  handleClose()
}

const handleClose = () => {
  if (isCriticalExpiredPassword.value) return

  showNotification.value = false
}

watch(
  [() => isCriticalExpiredPassword.value, () => isExpireSoonPassword.value],
  ([newCriticalExpiredPassword, newExpireSoonPassword]) => {
    // Always show critical expiration notifications
    if (newCriticalExpiredPassword) {
      showNotification.value = true
      return
    }

    // For soon to expire notifications, check if we should show it today
    if (newExpireSoonPassword) {
      // Show only if not shown today
      if (!wasShownToday()) {
        showNotification.value = true
        markAsShown()
      }
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  padding: 0 20px;
}

.notification-content {
  text-align: center;
  padding: 16px;

  p {
    margin-bottom: 16px;
    font-size: 16px;
  }
}

.notification-actions {
  display: flex;
  gap: 15px;
  justify-content: center;

  .btn {
    min-width: 150px;
  }
}
</style>
